import styled from 'styled-components';
import { NavBar } from 'ui/navigation/navbar';
import { BackofficeNavigation } from 'pages/backoffice/BackofficeNavigation';


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  width: 100%;
  background-color: #ebebeb;
  color: #000000;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export const ChildContainer = styled.div`
  flex: 1;
`;


export const Page = ({ children, title }) => {
  return (
    <Container>
      <ChildContainer>
      {children}
      </ChildContainer>
    </Container>
  )
}


export const BackofficeContainer = ({ children }) => {
  return (
    <Container>
      <NavBar>
        <BackofficeNavigation />
      </NavBar>
      <ChildContainer>
        {children}
      </ChildContainer>
    </Container>
  );
}
